import { CaptureRect } from "./CaptureRequest";

// Capture UI v2 hand-off: the sent screenshot / recording flies into the
// card. The editor reports where its image sits; the store turns the sent
// image into a small data: URL the host can draw (a host page can't load the
// Messenger's blob: URLs when the frame is cross-origin).

let editorImageRect: CaptureRect | undefined;

/** The editor's image on screen (frame client coordinates), per redraw. */
export const setCaptureEditorImageRect = (rect?: CaptureRect) => {
  editorImageRect = rect;
};

export const getCaptureEditorImageRect = (): CaptureRect | undefined =>
  editorImageRect;

export const prefersReducedMotion = (): boolean => {
  try {
    return (
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  } catch (_) {
    return false;
  }
};

const FLIGHT_IMAGE_EDGE = 640;

/**
 * A JPEG data: URL of the image, long edge ≤ 640 px. Undefined when the
 * browser can't decode or draw it (the card then just fades in).
 */
export const makeCaptureFlightImage = async (
  blob: Blob,
): Promise<string | undefined> => {
  try {
    if (typeof createImageBitmap !== "function") {
      return undefined;
    }
    const bitmap = await createImageBitmap(blob);
    const scale = Math.min(
      1,
      FLIGHT_IMAGE_EDGE / Math.max(1, bitmap.width, bitmap.height),
    );
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    const context = canvas.getContext("2d");
    if (!context) {
      return undefined;
    }
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    if (typeof bitmap.close === "function") {
      bitmap.close();
    }
    return canvas.toDataURL("image/jpeg", 0.8);
  } catch (_) {
    return undefined;
  }
};
